"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect, useRef } from "react";
import PageHeading from "../page-heading";

type InstrumentHeaderProps = {
  instrument: {
    feed: number;
    ticker: string;
  };
};

const ID = "instrument-header";

const InstrumentHeader = (props: InstrumentHeaderProps) => {
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions =
        new window.Infront.InstrumentSingleValueWidgetOptions();

      widgetOptions.instrument = new window.Infront.Instrument(
        props.instrument.feed,
        props.instrument.ticker
      );

      widgetOptions.name = "COUNTRY_OF_INCORPORATION";
      widgetOptions.translate = (_: any, value: string) => {
        return `<div class="!w-[30px] !h-[30px] cell-flag cell-flag-${value?.toLowerCase()}" title="${value}"></div>`;
      };

      widgetRef.current = window.infront.instrumentSingleValueWidget(
        `${ID}-country`,
        widgetOptions
      );
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, props.instrument]);

  return (
    <div className="flex items-center space-x-2">
      <div className="w-[30px] h-[30px]" id={`${ID}-country`}></div>
      <PageHeading text={props.instrument.ticker} />
    </div>
  );
};

export default InstrumentHeader;
